import React from 'react'

import { Col, Row, Alert, Table, Portlet, Divider } from '_zari/core'

import * as FormGroups from './formGroups'

const VistaDocumentoSection = ({ documentoData }) => {
  return (
    <>
      {(documentoData.flagDadoDeBaja || documentoData.flagAnulado) && (
        <>
          {documentoData.flagDadoDeBaja ? (
            <Alert color='danger'>El documento ha sido dado de baja.</Alert>
          ) : (
            <Alert color='danger'>El documento ha sido anulado.</Alert>
          )}
        </>
      )}
      <Portlet className='mb-3'>
        <Portlet.Body>
          <Row>
            <Col md={12}>
              <Row>
                <Col md={4}>
                  <FormGroups.TipoDocumentoFormGroup value={documentoData.tipoDocumento} />
                </Col>
                <Col md={4}>
                  <FormGroups.CodigoSerieFormGroup value={documentoData.serieDocumento} />
                </Col>
                <Col md={4}>
                  <FormGroups.NumeroSerieFormGroup value={documentoData.numeroDocumento} />
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <FormGroups.DocumentoSocioFormGroup value={documentoData.documentoSocio} />
                </Col>
                <Col md={4}>
                  <FormGroups.NombreSocioFormGroup value={documentoData.nombreSocio} />
                </Col>
                <Col md={4}>
                  <FormGroups.MonedaFormGroup value={documentoData.moneda} />
                </Col>
              </Row>
            </Col>
          </Row>
          <Divider noMargin />
          <Table.ClientSide
            filas={documentoData.detalles}
            headRows={[
              { label: 'COD' },
              { label: 'PRODUCTO' },
              { label: 'CANTIDAD' },
              { label: 'U. MEDIDA' },
              { label: 'PRECIO U.' },
              { label: 'TOTAL' }
            ]}
            rowTemplate={row => (
              <Table.Row hover key={row._id}>
                <Table.Cell>{row.codigoProducto}</Table.Cell>
                <Table.Cell>{row.nombreProducto}</Table.Cell>
                <Table.Cell>{row.cantidad}</Table.Cell>
                <Table.Cell>{row.unidadMedida}</Table.Cell>
                <Table.Cell>{row.precio}</Table.Cell>
                <Table.Cell>{row.total}</Table.Cell>
              </Table.Row>
            )}
          />
          <Row>
            <Col md={8} />
            <Col md={4}>
              <FormGroups.MontoTotalFormGroup value={parseFloat(documentoData.montoValorVentaTotal).toFixed(2)} />
            </Col>
          </Row>
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default VistaDocumentoSection
